import { cn } from "@tellescope/ui";
import { VideoParticipant } from "./VideoParticipant";
import type { ParticipantGridProps } from "../types";

/**
 * ParticipantGrid - Dynamic grid layout for video participants.
 *
 * Automatically adjusts grid columns based on the number of participants.
 */
export function ParticipantGrid({ participants, resolveParticipantIdentity, className }: ParticipantGridProps) {
  // Determine grid layout based on participant count
  const getGridClass = () => {
    const count = participants.length;
    if (count === 0) return "";
    if (count === 1) return "grid-cols-1";
    if (count === 2) return "grid-cols-2";
    if (count <= 4) return "grid-cols-2";
    if (count <= 6) return "grid-cols-3";
    return "grid-cols-3 md:grid-cols-4";
  };

  if (participants.length === 0) {
    return null;
  }

  return (
    <div className={cn("absolute inset-0 grid gap-2 p-2", getGridClass(), className)}>
      {participants.map((participant) => (
        <VideoParticipant
          key={participant.sid}
          participant={participant}
          resolveIdentity={resolveParticipantIdentity}
        />
      ))}
    </div>
  );
}
